import React from 'react';

import classNames from 'classnames';
import DownloadPdfIcon from 'icons/ic-download-pdf.svg';
import { useTranslation } from 'react-i18next';

export default function PdfDownloadContainer({
  BrandedLink,
  createdAt,
  downloadHref,
  fileSize,
  title,
  viewHref,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'messages.PdfDownloadContainer',
  });

  const { t: i18nTCommon } = useTranslation('common');

  return (
    <div
      className={classNames(
        'document-container tw-bg-grey-050',
        title === i18nTCommon('training.trainingReport') && 'tw-mt-4',
      )}
    >
      <DownloadPdfIcon />
      <div className='tw-ml-3'>
        <div className='download-container__title tw-font-semibold tw-text-grey-900'>
          {title}
        </div>
        <div className='download-container__sub-text tw-mb-2'>
          {i18nT('createdAt', { createdAt, fileSize })}
        </div>
        <span className='tw-mr-5'>
          <BrandedLink
            linkText={i18nTCommon('shared.view')}
            styleClasses='tw-font-semibold'
            target='_blank'
            url={viewHref}
          />
        </span>
        <BrandedLink
          linkText={i18nTCommon('shared.download')}
          styleClasses='tw-font-semibold'
          url={downloadHref}
        />
      </div>
    </div>
  );
}
